import angular from 'angular'
import React from 'react'
import 'react-dom'

angular.module('pub.bundle.step5.react', []).factory('TableStep5', TableStep5)

function TableStep5(
  $stateParams,
  $q,
  SetsService,
  OddsService,
  ChannelsService,
  BundleService,
  BundleCache,
) {
  return React.createClass({
    displayName: 'TableStep5',
    propTypes: {
      s3: React.PropTypes.string,
    },
    getDefaultProps: function () {
      return { s3: '' }
    },
    getInitialState: function () {
      return {
        sets: [],
        odds: [],
        oddsOtherSets: [],
        guaranteedAmout: 0,
        model: {},
        ptf: 1,
        isMax: false,
        s3: '',
      }
    },
    componentDidMount: function () {
      if ($stateParams.channelId) {
        var cb = callback.bind(this)
        cb($stateParams.channelId)
      } else {
        SetsService.get($stateParams.parentId).then(callback.bind(this))
      }

      function callback(data) {
        var channelId = $stateParams.channelId
        if (typeof data !== 'string') {
          channelId = data.results['id-ch']
        }

        var promises = {
          bundle: BundleService.getId($stateParams.parentId, $stateParams.id),
          sets: SetsService.getChannelId(channelId),
          odds: OddsService.get($stateParams.id),
          channels: ChannelsService.get(),
        }

        if (!$stateParams.channelId) {
          promises.set = SetsService.get($stateParams.parentId)
        }

        $q.all(promises).then(success.bind(this))

        function success(result) {
          var model = result.bundle.results
          var sets = result.sets.results
          var odds = result.odds.results
          var channels = result.channels.results
          var set = null
          if (result.set) {
            set = result.set.results
          }
          var lenSet = sets.length
          var lenChannel = channels.length
          var ownSet = []
          var ownChannel = []
          var otherOdds = []
          var otherSets = []
          var otherChannels = []

          for (var j = 0; j < odds.length; j++) {
            odds[j].oddsPer = 0
            if (odds[j].g) {
              odds[j].o = 1000
              this.state.guaranteedAmout += 1
            }

            odds[j].t = odds[j].q.t
            odds[j].txt = odds[j].q.txt
            odds[j]['img-t'] = odds[j].q['img-t']
            odds[j].cr = odds[j].q.cr
            odds[j].st = odds[j].q.st
            odds[j].bc = odds[j].q.bc
            odds[j].e = odds[j].q.e
            odds[j].em = odds[j].q.em
            odds[j].bc = odds[j].q.bc
            odds[j].n = odds[j].q.n

            if (odds[j].q['id-s'] !== parseInt($stateParams.parentId)) {
              otherOdds.push(odds[j])
              odds.remove(odds[j])
              if (j === 0) {
                j = -1
              } else {
                j = j - 1
              }
            }
          }

          otherOdds = _.uniq(otherOdds)

          var lenotherOdds = otherOdds.length
          for (var i = 0; i < lenSet; i++) {
            if (!sets[i].remainingUsing) {
              sets[i].remainingUsing = 0
            }

            for (var j = 0; j < lenotherOdds; j++) {
              if (sets[i].id === otherOdds[j].q['id-s']) {
                otherOdds[j].t = otherOdds[j].q.t
                otherOdds[j].txt = otherOdds[j].q.txt
                otherOdds[j]['img-t'] = otherOdds[j].q['img-t']
                otherOdds[j].crs = otherOdds[j].q.crs
                otherOdds[j].e = otherOdds[j].q.e
                otherOdds[j].em = otherOdds[j].q.em
                otherOdds[j].bc = otherOdds[j].q.bc
                otherOdds[j].n = otherOdds[j].q.n
                if (sets[i].q === undefined) {
                  sets[i].q = []
                }
                sets[i].remainingUsing += otherOdds[j].cr
                sets[i].q.push(otherOdds[j])
                otherSets.push(sets[i])
              }
              otherOdds[j].sop = 0
              otherOdds[j].sopb = 0
              otherOdds[j].oop = 0
              otherOdds[j].oopb = 0
            }

            sets[i].pds = 0
            sets[i].sto = 0

            if (sets[i].id === parseInt($stateParams.parentId)) {
              if (sets[i]['k-prod'] === 3) {
                this.state.ptf = 20
              } else if (sets[i]['k-prod'] === 2) {
                this.state.ptf = 1
              } else if (sets[i]['k-prod'] === 1) {
                this.state.ptf = 1
              }
              sets[i].colapse = false
              ownSet.push(sets[i])
            }
          }

          ownSet = _.uniq(ownSet)
          otherSets = _.merge(_.uniq(otherSets))
          var newQuids = []

          for (var i = 0; i < otherSets.length; i++) {
            var la = _.filter(otherSets, function (o) {
              return o.id === otherSets[i].id
            })
            if (la.length > 1) {
              for (var j = 0; j < la.length; j++) {
                for (var h = 0; h < la[j].q.length; h++) {
                  newQuids.push(la[j].q[h])
                }
              }
              otherSets[i].q = _.orderBy(_.uniq(newQuids), 'n')
            }
          }

          otherSets = _.uniqBy(otherSets, 'id')
          if (otherSets.length > 0) {
            for (var i = 0; i < otherSets.length; i++) {
              otherSets[i].colapse = false
              if (otherSets[i].q.length === 0) {
                otherSets.remove(otherSets[i])
                if (i === 0) {
                  i = -1
                } else {
                  i = i - 1
                }
              }
            }
            for (var i = 0; i < odds.length; i++) {
              if (odds[i].q !== undefined) {
                if (odds[i].q['id-s'] !== parseInt($stateParams.parentId)) {
                  odds.remove(odds[i])
                  if (i === 0) {
                    i = -1
                  } else {
                    i = i - 1
                  }
                }
              }
            }
          }

          // channels flow
          var lenotherOdds = otherOdds.length
          for (var i = 0; i < lenChannel; i++) {
            if (!channels[i].remainingUsing) {
              channels[i].remainingUsing = 0
            }

            for (var j = 0; j < lenotherOdds; j++) {
              if (channels[i].id === otherOdds[j].q.s['id-ch']) {
                otherOdds[j].t = otherOdds[j].q.t
                otherOdds[j].txt = otherOdds[j].q.txt
                otherOdds[j]['img-t'] = otherOdds[j].q['img-t']
                otherOdds[j].crs = otherOdds[j].q.crs
                otherOdds[j].e = otherOdds[j].q.e
                otherOdds[j].em = otherOdds[j].q.em
                otherOdds[j].bc = otherOdds[j].q.bc
                otherOdds[j].n = otherOdds[j].q.n
                if (channels[i].q === undefined) {
                  channels[i].q = []
                }
                channels[i].remainingUsing += otherOdds[j].cr
                channels[i].q.push(otherOdds[j])
                otherChannels.push(channels[i])
              }
              otherOdds[j].sop = 0
              otherOdds[j].sopb = 0
              otherOdds[j].oop = 0
              otherOdds[j].oopb = 0
            }

            channels[i].pds = 0
            channels[i].sto = 0

            if (set) {
              if (channels[i].id === set['id-ch']) {
                channels[i].colapse = false
                ownChannel.push(channels[i])
              }
            }
            //  else {
            //   channels[i].colapse = false;
            //   ownChannel.push(channels[i]);
            // }
          }

          otherChannels = _.merge(_.uniq(otherChannels))

          var newCollectibles = []
          for (var i = 0; i < otherChannels.length; i++) {
            var la = _.filter(otherChannels, function (o) {
              return o.id === otherChannels[i].id
            })
            if (la.length > 1) {
              for (var j = 0; j < la.length; j++) {
                for (var h = 0; h < la[j].q.length; h++) {
                  newCollectibles.push(la[j].q[h])
                }
              }
              otherChannels[i].q = _.orderBy(_.uniq(newCollectibles), 'n')
            }
          }

          console.log('6', otherSets)

          otherChannels = _.uniqBy(otherChannels, 'id')
          if (otherChannels.length > 0) {
            for (var i = 0; i < otherChannels.length; i++) {
              otherChannels[i].colapse = false
              if (otherChannels[i].q.length === 0) {
                otherChannels.remove(otherChannels[i])
                if (i === 0) {
                  i = -1
                } else {
                  i = i - 1
                }
              }
            }
          }

          if (ownChannel.length > 0) {
            for (var i = 0; i < ownChannel.length; i++) {
              otherChannels.remove(ownChannel[i])
            }
          } else {
            otherChannels = _.uniqBy(otherChannels, 'id')
          }

          var setFromChannels = []
          for (var x = 0; x < otherChannels.length; x++) {
            for (var y = 0; y < otherChannels[x].q.length; y++) {
              var exist = _.find(setFromChannels, {
                id: otherChannels[x].q[y].q.s.id,
              })
              if (!exist) {
                otherChannels[x].q[y].q.s.q = []
                setFromChannels.push(otherChannels[x].q[y].q.s)
              }
            }
          }

          for (var x = 0; x < setFromChannels.length; x++) {
            var collectiblesFromThisSet = []
            for (var y = 0; y < otherChannels.length; y++) {
              for (var z = 0; z < otherChannels[y].q.length; z++) {
                if (otherChannels[y].q[z].q.s.id === setFromChannels[x].id) {
                  collectiblesFromThisSet.push(otherChannels[y].q[z])
                }
              }
            }
            collectiblesFromThisSet = _.uniqBy(collectiblesFromThisSet, 'id')
            setFromChannels[x].q = collectiblesFromThisSet
          }

          for (var x = 0; x < setFromChannels.length; x++) {
            otherSets.push(setFromChannels[x])
          }

          otherChannels = _.uniqBy(otherChannels, 'id')
          otherSets = _.uniqBy(otherSets, 'id')

          BundleCache.addOddsOtherSets(otherSets, true)
          BundleCache.addOdds(odds)
          odds = _.orderBy(odds, 'n')
          if (ownSet.length > 0) {
            ownSet[0].q = odds
          }

          this.setState({
            odds: ownSet,
            oddsOtherSets: otherSets,
            model: model,
            sets: sets,
          })
          this.updateOddPer(true)
        }
      }
    },
    componentWillUpdate: function () {
      BundleCache.addStep3(this.state.odds, this.state.oddsOtherSets)
    },
    oddsRecursive: function (data) {
      var count = 0
      for (var i = 0; i < data.length; i++) {
        if (data[i].g !== undefined) {
          if (data[i].g === false) {
            count += data[i].o
          }
        } else {
          count += data[i].o
        }
      }
      return count
    },
    oddsRecursiveV: function (data) {
      var count = 0
      for (var i = 0; i < data.length; i++) {
        if (data[i].g !== undefined) {
          if (data[i].g === false) {
            count += data[i].ov
          }
        } else {
          count += data[i].ov
        }
      }
      return count
    },
    updateOddPer: function (isPds) {
      //get state
      var odds = this.state.odds
      // if (odds.length === 0) {
      //   return;
      // }

      var oddsOtherSets = this.state.oddsOtherSets
      //default values
      var recursive = null
      if (odds && odds.length > 0) {
        recursive = this.oddsRecursive(odds[0].q)
      }
      var recursiveOtherSets = 0
      for (var j = 0; j < oddsOtherSets.length; j++) {
        recursiveOtherSets += this.oddsRecursive(oddsOtherSets[j].q)
      }

      function allGuaranteed(data) {
        var allGuaranteed = false
        if (data.q !== undefined) {
          for (var v = 0; v < data.q.length; v++) {
            if (data.q[v].g) {
              allGuaranteed = true
            } else {
              allGuaranteed = false
              break
            }
          }
        }
        return allGuaranteed
      }

      if (odds && odds.length > 0) {
        //Percent of draws from this set
        if (isPds) {
          odds[0].pds = parseFloat(
            ((recursive / (recursive + recursiveOtherSets)) * 100).toFixed(2),
          )
          if (isNaN(odds[0].pds)) {
            odds[0].pds = 0
          } else if (!isFinite(odds[0].pds)) {
            odds[0].pds = 100
          }

          //all guaranteed
          if (allGuaranteed(odds[0])) {
            odds[0].pds = 100
          }
        }
        odds[0].sto = recursive
      }
      for (var i = 0; i < oddsOtherSets.length; i++) {
        if (isPds) {
          var firstCalculate = this.oddsRecursive(oddsOtherSets[i].q)
          oddsOtherSets[i].pds = parseFloat(
            ((firstCalculate / (recursive + recursiveOtherSets)) * 100).toFixed(2),
          )
          if (isNaN(oddsOtherSets[i].pds)) {
            oddsOtherSets[i].pds = 0
          } else if (!isFinite(oddsOtherSets[i].pds)) {
            oddsOtherSets[i].pds = 100
          }
          if (allGuaranteed(oddsOtherSets[i])) {
            oddsOtherSets[i].pds = 100
          }
        }
        oddsOtherSets[i].sto = this.oddsRecursive(oddsOtherSets[i].q)
        oddsOtherSets[i].sro = this.oddsRecursive(oddsOtherSets[i].q)
      }

      if (odds && odds.length > 0) {
        for (var i = 0; i < odds[0].q.length; i++) {
          //odds draw
          odds[0].q[i].oddsPer = 0
          odds[0].q[i].oddsPer = recursive

          //sop
          var sop = odds[0].q[i].o / recursive
          if (!isNaN(sop) && isFinite(sop)) {
            odds[0].q[i].sop = (sop * 100).toFixed(2)
          } else if (isNaN(sop)) {
            odds[0].q[i].sop = 0
          } else if (!isFinite(sop)) {
            odds[0].q[i].sop = parseFloat(100).toFixed(2)
          }

          //sopb
          var sopb = 1 - Math.pow(1 - sop, this.state.model.cd)
          if (!isNaN(sopb) && isFinite(sopb)) {
            odds[0].q[i].sopb = (sopb * 100).toFixed(2)
          } else if (isNaN(sopb)) {
            odds[0].q[i].sopb = 0
          } else if (!isFinite(sopb)) {
            odds[0].q[i].sopb = parseFloat(100).toFixed(2)
          }

          //oop
          var oop = odds[0].q[i].o / (recursive + recursiveOtherSets)
          if (!isNaN(oop) && isFinite(oop)) {
            odds[0].q[i].oop = (oop * 100).toFixed(2)
          } else if (isNaN(oop)) {
            odds[0].q[i].oop = 0
          } else if (!isFinite(oop)) {
            odds[0].q[i].oop = parseFloat(100).toFixed(2)
          }

          //oopb
          var oopb = 1 - Math.pow(1 - oop, this.state.model.cd)
          if (!isNaN(oopb) && isFinite(oopb)) {
            odds[0].q[i].oopb = (oopb * 100).toFixed(2)
          } else if (isNaN(oopb)) {
            odds[0].q[i].oopb = 0
          } else if (!isFinite(oopb)) {
            odds[0].q[i].oopb = parseFloat(100).toFixed(2)
          }
        }
      }

      for (var i = 0; i < oddsOtherSets.length; i++) {
        for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
          var otherRecursive = this.oddsRecursive(oddsOtherSets[i].q)
          oddsOtherSets[i].q[k].oddsPer = 0
          oddsOtherSets[i].q[k].oddsPer = this.oddsRecursive(oddsOtherSets[i].q)

          //sop
          var sop = oddsOtherSets[i].q[k].o / otherRecursive
          if (!isNaN(sop) && isFinite(sop)) {
            oddsOtherSets[i].q[k].sop = (sop * 100).toFixed(2)
          } else if (isNaN(sop)) {
            oddsOtherSets[i].q[k].sop = 0
          } else if (!isFinite(sop)) {
            oddsOtherSets[i].q[k].sop = parseFloat(100).toFixed(2)
          }

          //sopb
          var sopb = 1 - Math.pow(1 - sop, this.state.model.cd)
          if (!isNaN(sopb) && isFinite(sopb)) {
            oddsOtherSets[i].q[k].sopb = (sopb * 100).toFixed(2)
          } else if (isNaN(sopb)) {
            oddsOtherSets[i].q[k].sopb = 0
          } else if (!isFinite(sopb)) {
            oddsOtherSets[i].q[k].sopb = parseFloat(100).toFixed(2)
          }

          //oop
          var oop = oddsOtherSets[i].q[k].o / (recursive + recursiveOtherSets)
          if (!isNaN(oop) && isFinite(oop)) {
            oddsOtherSets[i].q[k].oop = (oop * 100).toFixed(2)
          } else if (isNaN(oop)) {
            oddsOtherSets[i].q[k].oop = 0
          } else if (!isFinite(oop)) {
            oddsOtherSets[i].q[k].oop = parseFloat(100).toFixed(2)
          }

          //oopb
          var oopb = 1 - Math.pow(1 - oop, this.state.model.cd)
          if (!isNaN(oopb) && isFinite(oopb)) {
            oddsOtherSets[i].q[k].oopb = (oopb * 100).toFixed(2)
          } else if (isNaN(oopb)) {
            oddsOtherSets[i].q[k].oopb = 0
          } else if (!isFinite(oopb)) {
            oddsOtherSets[i].q[k].oopb = parseFloat(100).toFixed(2)
          }
        }
      }

      var sum = 0
      if (odds && odds.length > 0) {
        sum = odds[0].pds
      }
      for (var i = 0; i < oddsOtherSets.length; i++) {
        sum += oddsOtherSets[i].pds
      }

      if (odds && odds.length > 0) {
        var rest = 100 - sum
        if (rest > 0) {
          odds[0].pds = parseFloat((odds[0].pds + rest).toFixed(2))
        }
      }

      this.setState({
        odds: odds,
        oddsOtherSets: oddsOtherSets,
      })

      this.forceUpdate()
    },
    dataCollapseOwn: function () {
      var odds = this.state.odds
      if (odds[0].colapse) {
        odds[0].colapse = false
        this.setState({
          odds: odds,
        })
        return
      }

      odds[0].colapse = !odds[0].colapse
      this.setState({
        odds: odds,
      })
    },
    dataCollapse: function (index) {
      var oddsOtherSets = this.state.oddsOtherSets
      if (oddsOtherSets[index].colapse) {
        oddsOtherSets[index].colapse = false
        this.setState({
          oddsOtherSets: oddsOtherSets,
        })
        return
      }

      oddsOtherSets[index].colapse = !oddsOtherSets[index].colapse
      this.setState({
        oddsOtherSets: oddsOtherSets,
      })
    },
    removeSoldOut: function () {
      var odds = this.state.odds
      var oddsOtherSets = this.state.oddsOtherSets
      var oddsToDelete = []

      for (var i = 0; i < odds[0].q.length; i++) {
        if (odds[0].q[i].st === 2) {
          oddsToDelete.push(odds[0].q[i].id)
        }
      }

      for (var i = 0; i < oddsOtherSets.length; i++) {
        for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
          if (oddsOtherSets[i].q[k].st === 2) {
            oddsToDelete.push(oddsOtherSets[i].q[k].id)
          }
        }
      }

      console.log('oddsToDelete', oddsToDelete)

      var promise = []

      for (var x = 0; x < oddsToDelete.length; x++) {
        promise.push(OddsService.deleteOdd(oddsToDelete[x]))
      }

      $q.all(promise).then(success.bind(this), error.bind(this))

      function success() {
        var odds = this.state.odds
        var oddsOtherSets = this.state.oddsOtherSets
        for (var i = 0; i < odds[0].q.length; i++) {
          for (var x = 0; x < oddsToDelete.length; x++) {
            if (odds[0].q[i].id === oddsToDelete[x]) {
              odds[0].q.remove(odds[0].q[i])
            }
          }
        }

        for (var i = 0; i < oddsOtherSets.length; i++) {
          for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
            for (var x = 0; x < oddsToDelete.length; x++) {
              if (oddsOtherSets[i].q[k].id === oddsToDelete[x]) {
                oddsOtherSets[i].q.remove(oddsOtherSets[i].q[k])
              }
            }
          }
        }

        console.log(odds)

        this.setState({
          odds: odds,
          oddsOtherSets: oddsOtherSets,
        })
        this.updateOddPer(true)
        this.dataCollapseOwn()
        this.forceUpdate()
        swal('Updated!', '', 'success')
      }

      function error(result) {
        swal(result.error.message, '', 'error')
      }

      // odds[0].q = newOdds
      // oddsOtherSets[index].q = newOddsOtherSets

      // this.setState({
      //   odds: odds,
      //   oddsOtherSets: oddsOtherSets,
      // })
      // this.updateOddPer(true)
    },
    allDefaultOdds: function () {
      var odds = this.state.odds
      var oddsOtherSets = this.state.oddsOtherSets

      for (var i = 0; i < odds.length; i++) {
        for (var k = 0; k < odds[i].q.length; k++) {
          odds[i].q[k].o = odds[i].q[k].bc * Math.pow(odds[i].q[k].em, odds[i].q[k].e - 1)

          if (odds[i].q[k].o === 0) {
            odds[i].q[k].o = 1000
          }

          odds[i].q[k].ov = odds[i].q[k].bc * Math.pow(odds[i].q[k].em, odds[i].q[k].e - 1)

          if (odds[i].q[k].ov === 0) {
            odds[i].q[k].ov = 1000
          }
        }
      }

      for (var i = 0; i < oddsOtherSets.length; i++) {
        for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
          oddsOtherSets[i].q[k].o =
            oddsOtherSets[i].q[k].bc *
            Math.pow(oddsOtherSets[i].q[k].em, oddsOtherSets[i].q[k].e - 1)

          if (oddsOtherSets[i].q[k].o === 0) {
            oddsOtherSets[i].q[k].o = 1000
          }

          oddsOtherSets[i].q[k].ov =
            oddsOtherSets[i].q[k].bc *
            Math.pow(oddsOtherSets[i].q[k].em, oddsOtherSets[i].q[k].e - 1)

          if (oddsOtherSets[i].q[k].ov === 0) {
            oddsOtherSets[i].q[k].ov = 1000
          }
        }
      }

      this.setState({
        odds: odds,
        oddsOtherSets: oddsOtherSets,
      })
      this.updateOddPer(true)
      this.forceUpdate()
    },
    defaultOdds: function (index, type) {
      var odds
      if (type === 'other') {
        odds = this.state.oddsOtherSets
        for (var i = 0; i < odds[index].q.length; i++) {
          odds[index].q[i].o =
            odds[index].q[i].bc * Math.pow(odds[index].q[i].em, odds[index].q[i].e - 1)

          if (odds[index].q[i].o === 0) {
            odds[index].q[i].o = 1000
          }

          odds[index].q[i].ov =
            odds[index].q[i].bc * Math.pow(odds[index].q[i].em, odds[index].q[i].e - 1)

          if (odds[index].q[i].ov === 0) {
            odds[index].q[i].ov = 1000
          }
        }
        this.setState({
          oddsOtherSets: odds,
        })
      } else {
        odds = this.state.odds
        for (var i = 0; i < odds[0].q.length; i++) {
          odds[0].q[i].o = odds[0].q[i].bc * Math.pow(odds[0].q[i].em, odds[0].q[i].e - 1)
          if (odds[0].q[i].o === 0) {
            odds[0].q[i].o = 1000
          }
          odds[0].q[i].ov = odds[0].q[i].bc * Math.pow(odds[0].q[i].em, odds[0].q[i].e - 1)

          if (odds[0].q[i].ov === 0) {
            odds[0].q[i].ov = 1000
          }
        }

        this.setState({
          odds: odds,
        })
      }

      this.updateOddPer(true)
      this.forceUpdate()
    },
    updateCalculate: function (index, indexDad, type, event) {
      this.minmax(index, indexDad, type, event.target.value)

      var odds = this.state.odds
      var oddsOtherSets = this.state.oddsOtherSets
      if (odds && odds.length > 0) {
        for (var i = 0; i < odds[0].q.length; i++) {
          odds[0].q[i].oddsPer = 0
          odds[0].q[i].oddsPer = this.oddsRecursive(odds[0].q)
        }
      }

      if (oddsOtherSets && oddsOtherSets.length > 0) {
        for (var i = 0; i < oddsOtherSets.length; i++) {
          for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
            oddsOtherSets[i].q[k].oddsPer = this.oddsRecursive(oddsOtherSets[i].q)
          }
        }
      }

      this.setState({
        odds: odds,
        oddsOtherSets: oddsOtherSets,
      })

      this.updateOddPer(false)
      // this.updateOddPerChannel(false);
    },
    minmax: function (index, indexDad, type, value) {
      var odds
      if (type === 'other') {
        odds = this.state.oddsOtherSets
      } else {
        odds = this.state.odds
      }
      var min = 0
      var max = 10000
      odds[indexDad].q[index].o = parseInt(value)
      if (parseInt(odds[indexDad].q[index].o) < min || isNaN(odds[indexDad].q[index].o)) {
        if (odds[indexDad].q[index].o === undefined) {
          odds[indexDad].q[index].o = 10000
        } else {
          odds[indexDad].q[index].o = 0
        }
      } else if (parseInt(odds[indexDad].q[index].o) > max) {
        odds[indexDad].q[index].o = 10000
      } else {
        odds[indexDad].q[index].o = odds[indexDad].q[index].o
      }

      if (type === 'other') {
        this.setState({
          oddsOtherSets: odds,
        })
      } else {
        this.setState({
          odds: odds,
        })
      }
    },
    changePds: function (index, event) {
      var odds = this.state.odds
      var oddsOtherSets = this.state.oddsOtherSets

      if (event.target.value === '') {
        oddsOtherSets[index].pds = 0
      } else {
        oddsOtherSets[index].pds = parseFloat(event.target.value)
        if (isNaN(oddsOtherSets[index].pds)) {
          oddsOtherSets[index].pds = 0
        }
      }

      if (
        oddsOtherSets[index].pds === 0 ||
        oddsOtherSets[index].pds === undefined ||
        oddsOtherSets[index].pds === null ||
        oddsOtherSets[index].pds === '' ||
        oddsOtherSets[index].pds === Infinity ||
        oddsOtherSets[index].pds === NaN ||
        oddsOtherSets[index].pds <= 0
      ) {
        // toastr.warning('The value is invalid.');
        // oddsOtherSets[index].pds = 0;
      } else {
        var pdsDad = 100
        for (var i = 0; i < oddsOtherSets.length; i++) {
          pdsDad -= parseFloat(oddsOtherSets[i].pds)
        }

        if (pdsDad <= 0) {
          toastr.warning('The base set must be at least 0.1%')
          return
        }

        odds[0].pds = parseFloat(pdsDad.toFixed(2))

        for (var i = 0; i < oddsOtherSets.length; i++) {
          oddsOtherSets[i].sto = (odds[0].sto * (oddsOtherSets[i].pds / odds[0].pds)).toFixed(2)
          for (var j = 0; j < oddsOtherSets[i].q.length; j++) {
            oddsOtherSets[i].q[j].ov = 0

            var math1 = Math.round(
              oddsOtherSets[i].q[j].o *
                (parseFloat(oddsOtherSets[i].sto) / parseFloat(oddsOtherSets[i].sro)),
            )
            if (!isNaN(math1)) {
              oddsOtherSets[i].q[j].ov = math1
            } else {
              oddsOtherSets[i].q[j].ov = 0
            }
          }
        }

        var recursive = this.oddsRecursive(odds[0].q)
        var recursiveOtherSets = 0
        for (var j = 0; j < oddsOtherSets.length; j++) {
          recursiveOtherSets += this.oddsRecursiveV(oddsOtherSets[j].q)
        }

        for (var i = 0; i < odds[0].q.length; i++) {
          //oop
          var oop = odds[0].q[i].o / (recursive + recursiveOtherSets)
          if (!isNaN(oop)) {
            odds[0].q[i].oop = (oop * 100).toFixed(2)
          } else {
            odds[0].q[i].oop = 0
          }

          //oopb
          var oopb = 1 - Math.pow(1 - oop, this.state.model.cd)
          if (!isNaN(oopb)) {
            odds[0].q[i].oopb = (oopb * 100).toFixed(2)
          } else {
            odds[0].q[i].oopb = 0
          }
        }

        for (var i = 0; i < oddsOtherSets.length; i++) {
          for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
            //oop
            var oop = oddsOtherSets[i].q[k].o / (recursive + recursiveOtherSets)
            if (!isNaN(oop)) {
              oddsOtherSets[i].q[k].oop = (oop * 100).toFixed(2)
            } else {
              oddsOtherSets[i].q[k].oop = 0
            }

            //oopb
            var oopb = 1 - Math.pow(1 - oop, this.state.model.cd)
            if (!isNaN(oopb)) {
              oddsOtherSets[i].q[k].oopb = (oopb * 100).toFixed(2)
            } else {
              oddsOtherSets[i].q[k].oopb = 0
            }
          }
        }

        //valid maximum
        for (var i = 0; i < oddsOtherSets.length; i++) {
          if (oddsOtherSets[i].pds >= 100) {
            oddsOtherSets[i].pds = 0
            toastr.warning('The base set must be at maximum 100%')
          }
        }
      }

      this.setState({
        odds: odds,
        oddsOtherSets: oddsOtherSets,
      })

      this.forceUpdate()
    },
    toogleSetGuaranteed: function (index, indexDad) {
      function howMuchGuaranteed(data) {
        var countGuaranteed = 0
        if (data.q !== undefined) {
          for (var v = 0; v < data.q.length; v++) {
            if (data.q[v].g) {
              countGuaranteed++
            }
          }
        }
        return countGuaranteed
      }

      if (!this.state.odds[indexDad].q[index].g) {
        var howMuch = howMuchGuaranteed(this.state.odds[indexDad])
        if (howMuch >= this.state.model.cd) {
          swal('Can Not Guarantee More Items Than Draws Available In Bundle', '', 'warning')
          return
        }
      }
      this.state.odds[indexDad].q[index].g = !this.state.odds[indexDad].q[index].g
      var odds = this.state.odds
      var oddsOtherSets = this.state.oddsOtherSets
      for (var i = 0; i < odds[0].q.length; i++) {
        odds[0].q[i].oddsPer = 0
        odds[0].q[i].oddsPer = this.oddsRecursive(odds[0].q)
      }

      for (var i = 0; i < oddsOtherSets.length; i++) {
        for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
          oddsOtherSets[i].q[k].oddsPer = this.oddsRecursive(oddsOtherSets[i].q)
        }
      }

      this.setState({
        odds: odds,
        oddsOtherSets: oddsOtherSets,
      })

      this.updateOddPer(true)
    },
    toogleOtherSetGuaranteed: function (index, indexDad) {
      function howMuchGuaranteed(data) {
        var countGuaranteed = 0
        if (data.q !== undefined) {
          for (var v = 0; v < data.q.length; v++) {
            if (data.q[v].g) {
              countGuaranteed++
            }
          }
        }
        return countGuaranteed
      }

      if (!this.state.oddsOtherSets[indexDad].q[index].g) {
        var howMuch = howMuchGuaranteed(this.state.oddsOtherSets[indexDad])
        if (howMuch >= this.state.model.cd) {
          swal('Can Not Guarantee More Items Than Draws Available In Bundle', '', 'warning')
          return
        }
      }

      this.state.oddsOtherSets[indexDad].q[index].g = !this.state.oddsOtherSets[indexDad].q[index].g
      var odds = this.state.odds
      var oddsOtherSets = this.state.oddsOtherSets
      if (odds && odds.length > 0) {
        for (var i = 0; i < odds[0].q.length; i++) {
          odds[0].q[i].oddsPer = 0
          odds[0].q[i].oddsPer = this.oddsRecursive(odds[0].q)
        }
      }

      if (oddsOtherSets && oddsOtherSets.length > 0) {
        for (var i = 0; i < oddsOtherSets.length; i++) {
          for (var k = 0; k < oddsOtherSets[i].q.length; k++) {
            oddsOtherSets[i].q[k].oddsPer = this.oddsRecursive(oddsOtherSets[i].q)
          }
        }
      }

      this.setState({
        odds: odds,
        oddsOtherSets: oddsOtherSets,
      })

      this.updateOddPer(true)
      // this.updateOddPerChannel(true);
    },
    render: function () {
      return React.createElement(
        'table',
        { className: 'table' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            { className: 'table-header' },
            React.createElement('th', null, 'Thumb'),
            React.createElement('th', null, 'Title'),
            React.createElement('th', null, 'Percent of draws from this set'),
            React.createElement('th', null, 'Set Total Odds'),
            React.createElement('th', null, 'Set Relative Odds'),
            React.createElement('th', null, '# of Cards'),
            React.createElement('th', null, 'Default Odds'),
            React.createElement(
              'td',
              { width: '150' },
              React.createElement('input', {
                type: 'button',
                className: 'btn btn-default bg-white float-right',
                onClick: this.allDefaultOdds.bind(this),
                value: 'All Default Odds',
              }),
            ),
            React.createElement(
              'td',
              { width: '150' },
              React.createElement('input', {
                type: 'button',
                className: 'btn btn-default bg-white float-right',
                onClick: this.removeSoldOut.bind(this),
                value: 'Remove Sold Out',
              }),
            ),
          ),
        ),
        React.createElement(
          'tbody',
          { style: { display: $stateParams.channelId ? 'none' : 'block' } },
          React.createElement(
            'tr',
            { style: { backgroundColor: '#eee', height: '35px' } },
            React.createElement(
              'td',
              { colSpan: '8' },
              React.createElement('label', { style: { marginLeft: '10px' } }, 'From this set'),
            ),
          ),
        ),
        this.state.odds.map(function (odd, i) {
          var url = this.props.s3 + '/sets/' + odd['img-t']
          var indexDad = i
          return React.createElement(
            'tbody',
            { key: i },
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { style: { width: '275px' } },
                React.createElement('img', {
                  style: { height: '75px', width: '75px' },
                  src: url,
                }),
              ),
              React.createElement('td', null, React.createElement('label', null, odd.t)),
              React.createElement(
                'td',
                { width: '250' },
                React.createElement('input', {
                  className: 'form-control',
                  value: odd.pds,
                  readOnly: true,
                }),
              ),
              React.createElement('td', null, odd.sto),
              React.createElement('td', null),
              React.createElement('td', null, odd.q.length),
              React.createElement(
                'td',
                { width: '150' },
                React.createElement('input', {
                  type: 'button',
                  className: 'btn btn-default',
                  onClick: this.defaultOdds.bind(this, i, 'odds'),
                  value: 'Default Odds',
                }),
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'pull-right' },
                  React.createElement(
                    'button',
                    {
                      className: 'btn btn-default',
                      onClick: this.dataCollapseOwn.bind(this, i),
                    },
                    React.createElement('span', null, 'Expand'),
                  ),
                ),
              ),
            ),
            odd.colapse === true
              ? React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    {
                      colSpan: '10',
                      style: { paddingLeft: '40px', width: '100%' },
                    },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'table',
                        { className: 'table' },
                        React.createElement(
                          'thead',
                          null,
                          React.createElement(
                            'tr',
                            { className: 'table-header' },
                            React.createElement('th', null, 'Sort'),
                            React.createElement('th', null, 'Thumb'),
                            React.createElement('th', null, 'Title'),
                            React.createElement('th', { width: '150' }, 'Odds Draw'),
                            React.createElement('th', null),
                            React.createElement('th', null, '%'),
                            React.createElement('th', null, 'Per Bundle'),
                            React.createElement('th', null, 'Per Draw'),
                            React.createElement('th', null, 'Per Bundle'),
                            React.createElement('th', null, 'Guaranteed'),
                          ),
                        ),
                        React.createElement(
                          'tbody',
                          null,
                          odd.q.map(function (children, i) {
                            var url = this.props.s3 + '/collectibles/' + children['img-t']
                            return React.createElement(
                              'tr',
                              { key: i },
                              React.createElement('td', null, children.n),
                              React.createElement(
                                'td',
                                { style: { width: '110px' } },
                                React.createElement('img', {
                                  style: { height: '75px', width: '75px' },
                                  'data-src': url,
                                  className: 'lazyload',
                                }),
                              ),
                              React.createElement('td', null, children.t),
                              React.createElement(
                                'td',
                                { width: '150' },
                                React.createElement('input', {
                                  type: 'text',
                                  max: 1000,
                                  min: 0,
                                  value: children.o,
                                  onChange: this.updateCalculate.bind(this, i, indexDad, 'odd'),
                                  className: 'form-control',
                                  width: '30',
                                }),
                              ),
                              React.createElement('td', null, children.o + ':' + children.oddsPer),
                              React.createElement('td', null, children.sop),
                              React.createElement('td', null, children.sopb),
                              React.createElement('td', null, children.oop),
                              React.createElement('td', null, children.oopb),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('input', {
                                  type: 'checkbox',
                                  checked: children.g,
                                  onChange: this.toogleSetGuaranteed.bind(this, i, indexDad),
                                }),
                              ),
                            )
                          }, this),
                        ),
                      ),
                    ),
                  ),
                )
              : React.createElement('tr', null),
          )
        }, this),
        React.createElement(
          'tbody',
          null,
          React.createElement(
            'tr',
            { style: { backgroundColor: '#eee', height: '35px' } },
            React.createElement(
              'td',
              { colSpan: '8' },
              React.createElement('label', { style: { marginLeft: '10px' } }, 'From others Sets'),
            ),
          ),
        ),
        this.state.oddsOtherSets.map(function (odd, i) {
          var url = this.props.s3 + '/sets/' + odd['img-t']
          var indexDad = i
          return React.createElement(
            'tbody',
            { key: i },
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { style: { width: '275px' } },
                React.createElement('img', {
                  style: { height: '75px', width: '75px' },
                  'data-src': url,
                  className: 'lazyload',
                }),
              ),
              React.createElement('td', null, React.createElement('label', null, odd.t)),
              React.createElement(
                'td',
                { width: '250' },
                React.createElement('input', {
                  className: 'form-control',
                  defautValue: odd.pds,
                  type: 'number',
                  value: odd.pds,
                  onChange: this.changePds.bind(this, i),
                }),
              ),
              React.createElement('td', null, odd.sto),
              React.createElement('td', null, odd.sro),
              React.createElement('td', null, odd.q.length),
              React.createElement(
                'td',
                { width: '150' },
                React.createElement('input', {
                  type: 'button',
                  className: 'btn btn-default',
                  onClick: this.defaultOdds.bind(this, i, 'other'),
                  value: 'Default Odds',
                }),
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'div',
                  { className: 'pull-right' },
                  React.createElement(
                    'button',
                    {
                      className: 'btn btn-default',
                      onClick: this.dataCollapse.bind(this, i),
                    },
                    React.createElement('span', null, 'Expand'),
                  ),
                ),
              ),
            ),
            odd.colapse === true
              ? React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    {
                      colSpan: '10',
                      style: { paddingLeft: '40px', width: '100%' },
                    },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'table',
                        { className: 'table' },
                        React.createElement(
                          'thead',
                          null,
                          React.createElement(
                            'tr',
                            { className: 'table-header' },
                            React.createElement('th', null, 'Sort'),
                            React.createElement('th', null, 'Thumb'),
                            React.createElement('th', null, 'Title'),
                            React.createElement('th', { width: '150' }, 'Odds Draw'),
                            React.createElement('th', null),
                            React.createElement('th', null, '%'),
                            React.createElement('th', null, 'Per Bundle'),
                            React.createElement('th', null, 'Per Draw'),
                            React.createElement('th', null, 'Per Bundle'),
                            React.createElement('th', null, 'Guaranteed'),
                          ),
                        ),
                        React.createElement(
                          'tbody',
                          null,
                          odd.q.map(function (children, i) {
                            var url = this.props.s3 + '/collectibles/' + children['img-t']
                            return React.createElement(
                              'tr',
                              { key: i },
                              React.createElement('td', { className: 'no-border-top' }, children.n),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('img', {
                                  style: { height: '75px', width: '75px' },
                                  'data-src': url,
                                  className: 'lazyload',
                                }),
                              ),
                              React.createElement('td', { className: 'no-border-top' }, children.t),
                              React.createElement(
                                'td',
                                { width: '150', className: 'no-border-top' },
                                React.createElement('input', {
                                  type: 'text',
                                  max: 1000,
                                  min: 0,
                                  value: children.o,
                                  onChange: this.updateCalculate.bind(this, i, indexDad, 'other'),
                                  className: 'form-control',
                                  width: '30',
                                }),
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                children.o + ':' + children.oddsPer,
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                children.sop,
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                children.sopb,
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                children.oop,
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                children.oopb,
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('input', {
                                  type: 'checkbox',
                                  checked: children.g,
                                  onChange: this.toogleOtherSetGuaranteed.bind(this, i, indexDad),
                                }),
                              ),
                            )
                          }, this),
                        ),
                      ),
                    ),
                  ),
                )
              : React.createElement('tr', null),
          )
        }, this),
      )
    },
  })
}
